import React from 'react';

// Hand-drawn (slightly wobbly) box, and a tick that stays inside it (an
// earlier version ran out past the top-right corner). pathLength={1} lets
// the draw-in animate stroke-dashoffset 1 -> 0 whatever the path's real
// length.
const BOX = 'M2.2 3 C8 2.4, 15 2.2, 21.6 2.8 C22 9, 21.8 15, 21.2 21.4 C15 21.9, 8.5 21.6, 2.6 21.2 C2.2 15, 2 9, 2.2 3 Z';
const TICK = 'M5.5 12.5 C7 14, 8.5 15.8, 10 17.8 C12.5 13, 15.3 9, 18.8 5.8';

// Filter pill for the Articles and Experience filters. The label stays
// neutral ink and the box is never filled: the category color lives only
// on the tick, drawn in when the filter is on.
const FilterCheck: React.FC<{ label: string; color: string; checked: boolean; onClick: () => void }> = ({ label, color, checked, onClick }) => (
  <button type="button" className="filter-check" aria-pressed={checked} onClick={onClick}>
    <span className="filter-check__box">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d={BOX} fill="none" stroke="currentColor" strokeWidth={1.3} strokeLinejoin="round" />
      </svg>
      <svg className="filter-check__tick" viewBox="0 0 24 24" aria-hidden="true">
        <path d={TICK} pathLength={1} fill="none" stroke={color} strokeWidth={2.8} strokeLinecap="round" strokeLinejoin="round" className="filter-check__draw" />
      </svg>
    </span>
    {label}
  </button>
);

export default FilterCheck;
